export default {
    it: {
        "base_label": "Data",
        "birthday": "Data di nascita",
        "date-error": "Scegli una data",
        "data_sessione": "Data sessione",

        "date-ok": ""
        
    },
    en: {
        "base_label": "Date",
        "date-error": "Choose a date",
        "data_sessione": "Session date",
        "date-ok": "",
        "birthday": "Birthday",
    }
}